// extracted by mini-css-extract-plugin
export default {"cls1":"PayoutHeader-VeloEmptyInfoIcon_cls1__P83DR","cls2":"PayoutHeader-VeloEmptyInfoIcon_cls2__O39rm PayoutHeader-VeloEmptyInfoIcon_cls1__P83DR"};